<script>
import DocumentListComponent from "./components/resources/DocumentListComponent.vue";
import AutoriryComponent from "./components/resources/AutoriryComponent.vue";
import NewsComponent from "./components/resources/NewsComponent.vue";
import ITCGridComponent from "./components/resources/ITCGridComponent.vue";
import BoxIconGridComponent from "./components/resources/BoxIconGridComponent.vue";
import MultiSliderComponent from "./components/resources/MultiSliderComponent.vue";
import FrecuentAccessComponent from "./components/resources/FrecuentAccessComponent.vue";
import GridLinkComponent from "./components/resources/GridLinkComponent.vue";
import CardGridComponent from "./components/resources/CardGridComponent.vue";
import ImgBanner from "./components/resources/ImgBanner.vue"
export default {
  name: "HomeView",
  components: {
    /* eslint-disable */
    DocumentListComponent,
    /* eslint-disable */
    AutoriryComponent,
    /* eslint-disable */
    NewsComponent,
    /* eslint-disable */
    ITCGridComponent,
    /* eslint-disable */
    BoxIconGridComponent,
    /* eslint-disable */
    MultiSliderComponent,
    /* eslint-disable */
    FrecuentAccessComponent,
    /* eslint-disable */
    GridLinkComponent,
    /* eslint-disable */
    CardGridComponent,
    ImgBanner
  },
  data() {
    return {
      site: 16,
    };
  },
  mounted() {
    document.title = process.env.VUE_APP_TITLE;
  },
};
</script>

<template>
  <ITCGridComponent 
    :columnas="2"
    titulo="Consultas"
    :data ="[
      {
        desc: null,
        icon: 'ptn-i-documento',
        target:'_self',
        title:'Consulta de expedientes',
        url:'?uid=CUMV-VIEW-ExpedientesComponent'  
      },
      {
        desc: null,
        icon: 'question_answer',
        target:'_self',
        title:'Consultas y solicitudes',
        url:'?uid=CUMV-VIEW-FormComponent'
      },
    ]"
  />

  <!-- <div class="container">
    <div class="row">
      <div class="col-md-12">
        <DocumentListComponent
          resultados="5"
          :show-fecha="false"
          titulo="Guía de Trámites"
          :filtros="{ site: this.site }"
        />
      </div>
    </div>
  </div> -->
  <ImgBanner/>

  <CardGridComponent
    columnas="1"
    :data="[
      {
        target: '_self',
        title: 'Licitaciones',
        url: 'https://licitaciones.sanjuan.gob.ar/',
      },
    ]"
  />

  <NewsComponent titulo="Noticias" />

  <Autoriry-component
  :showProtocolo="false"
    :showLinks="true"
    :data="[
      {
        title: 'Federico Ríos Yañez',
        subtitle: 'Secretario de Ambiente y Desarrollo Sustentable',
        imagen: require('@/assets/img/secdeambiente.jpg'),
      },
    ]"
  />
</template>
